'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import utils from 'services/utils';
import classNames from 'classnames';

const propTypes = {
    heading: PropTypes.string,
    content: PropTypes.string,
};

class PopoverContentSection extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        const heading = (this.props.heading) ? <b>{this.props.heading}.&nbsp;</b> : null;
        
        return (
            <p>
                {heading}
                {this.props.children}
            </p>
        );
    }
}

PopoverContentSection.propTypes = propTypes;
export default PopoverContentSection;
